import React, { useEffect } from "react";
import useSelectorId from "../../../../utilities/hooks/useSelectorId";
import { ECLRange } from "../../../index";
import debounce from "../../../../utilities/debounce";
import "./ECLSliderBlock.css";
import { updateServerSession } from "../../../../utilities/requests";

export default function ECLSliderBlock(props) {
   const instanceID = useSelectorId();
   //Debounce the signal that let's us know when someone has submitted something into input, but hasn't touched it in a couple seconds
   const signalInput = debounce(() => {
      const formElement = document.querySelector(`#slider-block-${instanceID}`); //get form element
      formElement.dispatchEvent(new CustomEvent("submitSignal")); //dispatch ready for submit event
   }, 250);

   //When "submitSignal" event occurs, do the thing with the current state
   const handleSignal = (e) => {
      const keyval = [
         {
            key: "slider",
            value: {
               current_value: Number(e.target[0].value),
            },
         },
      ];
      updateServerSession(props, keyval);
   };

   useEffect(() => {
      const formElement = document.querySelector(`#slider-block-${instanceID}`);
      if (formElement) {
         formElement.addEventListener("input", signalInput);
         formElement.addEventListener("submitSignal", handleSignal);
         return () => {
            formElement.removeEventListener("input", signalInput);
            formElement.removeEventListener("submitSignal", handleSignal);
         };
      }
   }, []);

   return (
      <form
         id={`slider-block-${instanceID}`}
         className="slider-block-container"
      >
         <ECLRange
            id={`slider-${instanceID}`}
            name={props.block.data.name}
            precision={2}
            min={props.block.data.min}
            max={props.block.data.max}
            value={Number(props.block.data.initial_value).toFixed(2)}
         />
      </form>
   );
}
